import Button from 'components/ui/button'
import { ButtonCTA } from 'components/ui/button-cta'

import BaseModal from '../base-modal'
import ModalContent from '../modal-content'
import ModalTitle from '../modal-title'
import type { ConversionFooter, ModalProps, TailwindMaxWidth } from '..'

export interface ConversionModalProps extends ModalProps {
  maxSize: TailwindMaxWidth
  image?: string
  footer?: ConversionFooter | false
  isLoading: boolean
  titleVariables?: string[]
  zIndex?: string
}

export default function ConversionModal({
  isOpen,
  onClose,
  title,
  titleClassName,
  icon,
  image,
  closeButton,
  footer,
  content,
  maxSize,
  isLoading,
  titleVariables,
  zIndex,
}: ConversionModalProps) {
  const hasFooter =
    footer &&
    typeof footer === 'object' &&
    'primary' in footer &&
    'cancel' in footer

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      closeButton={closeButton}
      maxSize={maxSize}
      zIndex={zIndex}
    >
      {image && (
        <img className="tw--mt-6 tw-w-full" src={image} alt="modal title" />
      )}
      <div className="tw-flex tw-flex-col tw-gap-4 tw-p-6">
        {title && (
          <ModalTitle
            text={title}
            icon={icon}
            orientation="center"
            customTextStyle={titleClassName}
            titleVariables={titleVariables}
          />
        )}
        <ModalContent orientation="center">{content}</ModalContent>
        {hasFooter && (
          <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
            <ButtonCTA
              onClick={footer.primary.onClick}
              size={footer.primary.size}
              isLoading={isLoading}
              disabled={footer.primary.disabled || isLoading}
              data-testid="cta-button"
              className={footer.primary.buttonClassName}
            >
              {footer.primary.buttonText}
            </ButtonCTA>
            <Button variant="legacy-onlyText" onClick={footer.cancel.onClick}>
              {footer.cancel.buttonText}
            </Button>
          </div>
        )}
      </div>
    </BaseModal>
  )
}
